import EventActionProto from '../event-action-proto'
import {EVENT_BUS_SESSION_CUSTOM_VIEW_UPDATE} from "./@const";

module.exports = class EventCustomViewUpdate extends EventActionProto {

    constructor(uid, data, fromSID, companyId) {
        super(uid, data, companyId)

        this.fromSID = fromSID
    }

    validate() { return true }

    process() {

        gd.session.customViews.update(this.data)

        // do not trigger event for user who initialed update
        if (this.fromSID !== gd.sessionId) {
            gd.bus.triggerEvent(EVENT_BUS_SESSION_CUSTOM_VIEW_UPDATE, gd.session.customViews.get(this.data.id))
        }

        super.process()
    }
}